module.exports = __webpack_public_path__ + "img/video-cover.99c6b030.jpg";